import { render, staticRenderFns } from "./SageQuoteModal.vue?vue&type=template&id=7613fad6&"
import script from "./SageQuoteModal.vue?vue&type=script&lang=js&"
export * from "./SageQuoteModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports